"use client";
import { ConfigData } from "@/models/config";
import { optionRoleSubscription } from "@/models/subscription";
import { User } from "@/models/user";
import { CopilotKit } from "@copilotkit/react-core";
import React from "react";

interface CopilotLayoutContentProps {
  children: React.ReactNode;
  user?: User | null;
  config?: ConfigData | null;
  lang: string;
}

const CopilotLayoutContent = ({
  children,
  user,
  config,
  lang,
}: CopilotLayoutContentProps) => {
  return (
    <CopilotKit
      runtimeUrl={process.env.NEXT_PUBLIC_COPILOTKIT_RUNTIME_URL}
      agent="data_search_chatbot"
      headers={{
        "x-copilotkit-runtime-url": (
          config?.urlAi ||
          process.env.NEXT_PUBLIC_COPILOTKIT_REMOTE_URL ||
          ""
        ).replace(/^"|"$/g, ""),
        "x-copilotkit-user": JSON.stringify({
          id: user?.id || "",
          email: encodeURIComponent(user?.email || ""),
          fullname: encodeURIComponent(
            user?.fullName
              ? `${user?.fullName || ""}`
              : `${user?.firstName || ""} ${user?.lastName || ""}`
          ),
          language: user?.language || lang,
          license: user?.license
            ? {
                name: encodeURIComponent(
                  user?.license.subscription?.name || ""
                ),
                validUntil: user?.license?.expiredDate || "",
                trial: user?.license.isTrial || false,
                isOrganizationLicense: !!user?.license?.organizationId || false,
                options: optionRoleSubscription
                  .filter((option) =>
                    user?.license?.subscription?.options
                      ?.map((item) => item)
                      .includes(option?.id)
                  )
                  .map((item) => item?.name),
              }
            : null,
          organization: user?.organization
            ? {
                id: user?.organization?.organization?.id || 0,
                name: encodeURIComponent(
                  user?.organization?.organization?.name || ""
                ),
              }
            : null,
        }),
      }}
    >
      {children}
    </CopilotKit>
  );
};

export default CopilotLayoutContent;
